module.exports = __webpack_public_path__ + "img/img58.8939a48b.svg";